import {PortalModule} from "@/services/store/modules/portals/PortalModule";
import {getInvestorPortal} from "@/lib/Portal";

export class InvestorModule extends PortalModule {
    public portal = getInvestorPortal();
}
